/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

import "../../css/event230228.css";
//import '../../css/event221217_2.css'
import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import { isMobile } from "react-device-detect";
// import { Modal } from "react-responsive-modal";

import Event202304_contentList from "./Event202304_contentList";

class Event202304_newContent extends Component {
  _goMeta = () => {
    window.open("https://zep.us/play/8jZlb0", "zep", "");
  };
  _go = () => {
    window.open("https://c11.kr/1bxmo", "", "");
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    let os = "";

    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );

    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        os = "android";
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1
      ) {
        os = "ios";
      } else {
        os = "otehr";
      }
    } else {
      os = "pc";
    }

    if (today <= "2021-12-28 00:00:00") {
      toast.warn("12월 28일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      if (os === "pc") {
        setTimelineWeek(true);
      } else {
        if (os === "ios") {
          setTimeout(function () {
            window.open("https://apps.apple.com/kr/app/id687631772", "", "");
          }, 1500);

          window.location.href = "aniplustv://TimeTable";
        } else {
          //setTimeout(function () {
          //window.open(android_appstore_url);
          //}, 1500);

          window.location.href = "aniplustv://TimeTable";
        }

        //this.action_app('aniplustv://TimeTable', 'aniplustv://TimeTable', 'https://itunes.apple.com/kr/app/instagram/id687631772', 'https://play.google.com/store/apps/details?id=com.aniplustv.android')
      }
    }
  };
  render() {
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="event_head">
          <h3>애니플러스 신작 이벤트</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <a name="top"></a>
          <div className="event230228">
            <div className="sticky">
              <div className="quick">
                <a href="#top">
                  <img
                    src={imgUrl + "/img/event/event230228/quick_01.png"}
                    alt="응모"
                  />
                </a>
                <a href="#newList">
                  <img
                    src="/img/event/event230228/quick_02.png"
                    alt="신작목록"
                  />
                </a>
                <a href="#gift">
                  <img
                    src={imgUrl + "/img/event/event230228/quick_03.png"}
                    alt="경품"
                  />
                </a>
                <a
                  href="#rules"
                  onClick={this._timeTable}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={imgUrl + "/img/event/event230228/quick_04.png"}
                    alt="요일별시간표"
                  />
                </a>
                <a href="#comment">
                  <img
                    src={imgUrl + "/img/event/event230228/quick_05.png"}
                    alt="댓글"
                  />
                </a>
              </div>
            </div>

            <div className="btm_bar">
              <a style={{ cursor: "pointer" }} onClick={this._goMeta}>
                <img
                  src={imgUrl + "/img/event/event230228/fix_btn.png"}
                  alt="애니플러스 신작월드"
                  className="img_web"
                />
                <img
                  src={imgUrl + "/img/event/event230228/m_fix_btn.png"}
                  alt="애니플러스 신작월드"
                  className="img_m"
                />
              </a>
            </div>

            <div className="main">
              <img
                src={imgUrl + "/img/event/event230228/backimg_1.png"}
                alt="애니플러스 신작 뽑기"
                className="img_web"
              />
              <img
                src={imgUrl + "/img/event/event230228/m_backimg_1.png"}
                alt="애니플러스 신작 뽑기"
                className="img_m"
              />
              <div className="top_ani">
                {/*<img src="/img/event/event230228/top_img.png" />*/}
              </div>
            </div>
            <div className="eventBody">
              <a name="newList"></a>
              <div className="listWrap">
                <h2>
                  <img
                    src={imgUrl + "/img/event/event230228/tit_1.png"}
                    alt="1회차 모험 전리품"
                    className="img_web"
                  />
                  <img
                    src={imgUrl + "/img/event/event230228/m_tit_1.png"}
                    alt="1회차 모험 전리품"
                    className="img_m"
                  />
                </h2>

                <Event202304_contentList eventCode={1} />
                <h2>
                  <img
                    src={imgUrl + "/img/event/event230228/tit_2.png"}
                    alt="2회차 모험 전리품"
                    className="img_web"
                  />
                  <img
                    src={imgUrl + "/img/event/event230228/m_tit_2.png"}
                    alt="2회차 모험 전리품"
                    className="img_m"
                  />
                </h2>
                <Event202304_contentList eventCode={2} />
                <h2>
                  <img
                    src={imgUrl + "/img/event/event230228/tit_3.png"}
                    alt="3회차 모험 전리품"
                    className="img_web"
                  />
                  <img
                    src={imgUrl + "/img/event/event230228/m_tit_3.png"}
                    alt="3회차 모험 전리품"
                    className="img_m"
                  />
                </h2>
                <Event202304_contentList eventCode={3} />
              </div>
            </div>
            <div className="btm">
              <a name="gift" className="link"></a>
              <img
                src={imgUrl + "/img/event/event230228/backimg_3.png"}
                alt="경품내용 및 주의사항"
                className="img_web"
              />

              <a style={{ cursor: "pointer" }} onClick={this._go}>
                <img
                  src={imgUrl + "/img/event/event230228/backimg_4.png"}
                  alt="경품내용 및 주의사항"
                  className="img_web"
                />
              </a>

              <img
                src={imgUrl + "/img/event/event230228/backimg_5.png"}
                alt="경품내용 및 주의사항"
                className="img_web"
              />
              <img
                src={imgUrl + "/img/event/event230228/m_backimg_3.png"}
                alt="경품내용 및 주의사항"
                className="img_m"
              />
              <a style={{ cursor: "pointer" }} onClick={this._go}>
                <img
                  src={imgUrl + "/img/event/event230228/m_backimg_4.png"}
                  alt="경품내용 및 주의사항"
                  className="img_m"
                />
              </a>
              <img
                src={imgUrl + "/img/event/event230228/m_backimg_5.png"}
                alt="경품내용 및 주의사항"
                className="img_m"
              />
            </div>
          </div>
        </div>
        <a name="comment"></a>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202304_newContent));
